<!-- <input 
  type="text" 
  class="filter-control" 
  (input)="findTextInTableData($event.target.value)"
  placeholder="Find..."> -->


<ag-grid-angular
    style="width: 80%; height: 350px;"
    class="ag-theme-balham"
    
    [rowData]="attachmentList"
    [columnDefs]="columnsAttachmentList"
    (gridReady)="onGridReady($event)"
    (cellClicked)='onCellClicked($event)'
    >
</ag-grid-angular>